import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { BaseSafeFormView, BaseView, BaseText } from '@/components/base'
import { StickyHeaderNavigation } from '@/components/StickyHeaderNavigation'
import { AppButton } from '@/components/AppButton'

export const KemCardDetailsScreen: React.FC = () => {
  const navigate = useNavigate()
  const [isCreating, setIsCreating] = useState(false)

  const handleCreateCard = async () => {
    setIsCreating(true)

    try {
      // API call to create card
      await new Promise((resolve) => setTimeout(resolve, 2000))

      // On success, navigate to main card screen
      navigate('/kem-card')
    } catch (error) {
      // On error, navigate to failure screen
      navigate('/kem-card/creation-failure')
    } finally {
      setIsCreating(false)
    }
  }

  return (
    <BaseSafeFormView flex={1} bgColor="background.screen" className="h-full">
      <StickyHeaderNavigation
        title="Card Details"
        onBackPress={() => navigate(-1)}
      />

      <BaseView p={20} gap={24} flex={1}>
        {/* Header */}
        <BaseView align="center" gap={16}>
          <BaseView
            p={16}
            rounded={20}
            style={{
              backgroundColor: '#2563eb',
              width: 60,
              height: 60,
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <BaseText fontSize={24} color="white">
              💳
            </BaseText>
          </BaseView>

          <BaseText
            fontSize={24}
            fontFamily="bold"
            color="label.default"
            textAlign="center"
          >
            Details About Your Kem Card
          </BaseText>
        </BaseView>

        {/* Card Details */}
        <BaseView gap={16}>
          <BaseView p={16} rounded={12} style={{ backgroundColor: '#1a1a1a' }}>
            <BaseText
              fontSize={16}
              fontFamily="medium"
              color="label.default"
              mb={8}
            >
              Card Features
            </BaseText>
            <BaseText
              fontSize={14}
              fontFamily="regular"
              color="label.description"
            >
              • Spend crypto anywhere Visa is accepted{'\n'}• Real-time
              notifications{'\n'}• No foreign transaction fees{'\n'}• Instant
              card controls
            </BaseText>
          </BaseView>

          <BaseView p={16} rounded={12} style={{ backgroundColor: '#1a1a1a' }}>
            <BaseText
              fontSize={16}
              fontFamily="medium"
              color="label.default"
              mb={8}
            >
              Important Information
            </BaseText>
            <BaseText
              fontSize={14}
              fontFamily="regular"
              color="label.description"
            >
              Your card will be issued within 1-2 business days. You'll receive
              a notification when it's ready.
            </BaseText>
          </BaseView>
        </BaseView>

        <BaseView style={{ marginTop: 'auto' }}>
          <AppButton
            onPress={handleCreateCard}
            disabled={isCreating}
            isLoading={isCreating}
            label={isCreating ? 'Creating Card...' : 'Create Card'}
            type="primaryGradient"
          />
        </BaseView>
      </BaseView>
    </BaseSafeFormView>
  )
}
